import React from 'react';
import PropTypes from 'prop-types';
import {
    BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME,
} from '../../constants';

import MostPopularFooter from './MostPopularFooter';
import MostRecentFooter from './MostRecentFooter';
import StartTimeFooter from './StartTimeFooter';

const BetCardFooter = ({betcard, commonDataEvents, type, sportName}) => {
    const options = {
        most_popular: <MostPopularFooter position={betcard.position} isTopBet={betcard.top_x} sportName={sportName} />,
        most_recent: <MostRecentFooter isTopBet={betcard.top_x} lastBetPlacedOn={betcard.last_bet_placed_on} />,
        start_time: <StartTimeFooter isTopBet={betcard.top_x} commonDataEvents={commonDataEvents} />,
    };
    const footer = options[type];


    return footer ? (
        <div className={`${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}`}>
            {footer}
        </div>
    ) : null;
};

BetCardFooter.propTypes = {
    betcard: PropTypes.instanceOf(Object).isRequired,
    commonDataEvents: PropTypes.instanceOf(Object).isRequired,
    type: PropTypes.oneOf(['most_popular', 'most_recent', 'start_time']),
    sportName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
};

BetCardFooter.defaultProps = {
    type: null,
    sportName: null,
};

export default BetCardFooter;
